(function accordionHeadAlwaysVisible() {
  const accordions = [ ...document.querySelectorAll('.ilc_va_ihead_VAccordIHead') ];

  accordions.forEach(item => {
    item.addEventListener('click', (e) => {
      const pane = e.target;

      setTimeout(() => {
        if (pane.getBoundingClientRect().top <= 90) {
          pane.scrollIntoView({
            behavior: 'smooth', block: 'nearest', inline: 'start'
          });
        }
      }, 400);
    });
  });
})();
